<template>
  <div v-if="establecimientoActual" class="w-full px-5 mx-auto">

    <div
      id="fuera"
      class="w-full h-full max-w-screen-xl block mt-0"

    >
      <iframe
        :src="iframeSrc"
        v-resize="{ log: true }"
        class="bg-gray-100"
         width="100%"
        frameborder="no"

        scrolling="no"
        id="iFrameResizer0"

      >Su navegador no soporta IFRAMES. Inténtelo con otro distinto.</iframe>
    </div>
        <!-- <div class="p-5">
          Envio:
        <div class="bg-blue-100 p-10 text-xs rounded">
          {{iframeSrc}}
        </div>
    </div> -->
  </div>
</template>
<script>
// import iFrameResize from "../assets/iframeResizer";

export default {
  props:['establecimientoActual'],
  data(){
    return {
       iframeBaseUrl: "https://ticket.kutxabank.es/biziberriz/public/janto/main.php?Nivel=Sesiones",
       
        
       iframeBaseUrlJSON: "https://ticket.kutxabank.es/biziberriz/public/janto/main.php?Nivel=Evento&idEvento=BBERRIZ",
    }
  },
  computed: {
    bonoActual(){
      const bonoActual = this.$store.state.bonoActual
      return bonoActual
    },
    queryRuta(){
      let parametros = ""

      const query = this.establecimientoActual
      delete query._highlightResult
      delete query.__position


      if (query) {
        Object.keys(query).forEach(clave=>{
        if (clave == 'ruta') {
          this.ruta = query['ruta']
        } else {
          parametros+=`&${clave}=${query[clave]}`
        }
          
        })

      }

      return parametros
    },
    iframeJSON(){
      const iframeBaseUrl = this.iframeBaseUrlJSON;
      const lang = this.$i18n.locale
      const Idioma = lang.toUpperCase()     
      const establecimientoActual = this.establecimientoActual
      establecimientoActual.Idioma = Idioma
      
      delete establecimientoActual._highlightResult
      delete establecimientoActual.__position
      //  Razón social que es el nombre del establecimiento, dirección , municipio y procedencia

      const objeto = {
        NOMBRE: establecimientoActual.NOMBRE,
        DIRECCION: establecimientoActual.DIRECCION,
        POBLACION: establecimientoActual.POBLACION,
        CODIGOPROCEDENCIA: establecimientoActual.CODIGOPROCEDENCIA,
        Idioma: Idioma
      }
      const json = encodeURIComponent(JSON.stringify(objeto))
      const respuesta = iframeBaseUrl +  '&json='+ json + "&Idioma=" + Idioma
      // console.log('restpuesta', respuesta)
      return respuesta
    },
    iframeSrc(){
      return this.iframeJSON
    },
    iframeQuery() {
      const iframeBaseUrl = this.iframeBaseUrl;
      const lang = this.$i18n.locale
      const Idioma = lang.toUpperCase()
      // const evento = this.detalleEvento;
      // const idRecinto = evento.Recinto[0].Id;
      // const idEvento = evento.Id;
      // const instala = evento.Instalacion.split("_")[1];
      const queryRuta = this.queryRuta

      return (
        iframeBaseUrl +
        "&Idioma=" +
        Idioma + queryRuta
      );
    }
  }
}
</script>
<style>
iframe {
  width: 1px;
  min-width: 100%;
  height: 1600px;
}
strong {
  font-weight: 600
}
</style>